// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"22":"7671385485f1bd9e","699":"04f49492e81684a7","715":"7d87c5f92054d248"}[chunkId] + ".js";
};